<template>
  <div class="edit-registration" :data-cy-form-view-type="viewType">
    <div v-if="readOnly" data-cy="preview-registration-notification" :class="`info-container attention`">
      <vwc-icon
          :class="`icon info-icon`"
          :type="`info`"
      />
      <div class="content">
        <h5
            class="content-header"
            v-html="$t('smsRegistrations.statusPage.previewRegistrationInfoBoxTitle')"
        />
        <div v-if="isVoluntaryEditEnabled" class="content-text" @click.prevent="handleStatusInfoClick" v-html="$t('smsRegistrations.statusPage.previewRegistrationInfoBoxText')" />
      </div>
    </div>
    <cd-modal
        class="modal"
        data-cy="important-update-modal"
        title="Important Update"
        :large="true"
        :canCancel = "false"
        okText = "Ok, Got it"
        :visible="isModalVisible"
        @close="isModalVisible = false"
        @confirm="isModalVisible= false"
        :no-footer ="true"
    >
      <vwc-icon class="modal-icon" type="megaphone-line" />
      <img class="image" src="@/assets/updatesRequiredModal.png" alt="Image"/>
      <p class="modal-text"  v-html="$t('smsRegistrations.updatesRequiredModalText')"/>
      <footer class="footer">
        <cd-button
            id="cancel"
            connotation="primary"
            layout="filled"
            label="Ok, Got it"
            @click= "isModalVisible= false"
        />
      </footer>
    </cd-modal>
    <register-step-form :steps="steps" :current-step="currentStep" :next-button-disabled="isNextDisabled"
                        @nextStep="currentStep++"
                        @previousStep="currentStep--"
                        :registerInProgress="registerInProgress"
                        :registered-type-name="stepFormType"
                        @registerAndPay="submitForm"
                        @cancel="closeForm"
                        :cancel-button="!readOnly"
                        :is-updates-required="isUpdatesRequired"
                        :read-only="readOnly">
      <general-details @pageValidityChange="onGeneralDetailsValid" slot="step-body-1" v-model="registrationDetails"
                       :registration-details="registrationDetails" :is-edit-view="true" :read-only="readOnly"></general-details>
      <messaging-description @pageValidityChange="onMessagingDescriptionValid" slot="step-body-2"
                             :company-name="registrationDetails.displayName" :company-url="registrationDetails.website" v-model="messagingDescriptionData"
                             :messaging-description-data="messagingDescriptionData" :read-only="readOnly"/>
      <message-content-type @pageValidityChange="onMessageContentValid" slot="step-body-3"
                            v-model="messageContentDetails" :message-content-details="messageContentDetails"
                            :company-name="registrationDetails.displayName" :read-only="readOnly"></message-content-type>
      <cd-button
          v-if="readOnly"
          slot="footer-buttons"
          class="close-preview-button"
          data-cy="close-preview-button"
          layout="outlined"
          connotation="primary"
          :label="$t('smsRegistrations.statusPage.closeRegistrationDetailsButton')"
          @click="closeForm"
      ></cd-button>
    </register-step-form>
  </div>
</template>

<script>
import RegisterStepForm from "../RegisterStepForm";
import MessagingDescription from "./MessagingDescription";
import MessageContentType from "./MessageContentType";
import {mapState, mapActions} from "vuex";
import tenDlcMixin from '../../mixins/tenDlcMixin';
import {
  convertMessagingDescriptionArrayToObj,
  convertRegistrationResponseToMessageContentPage,
  convertRegistrationResponseToMessagingDescriptionPage, handleMessagingDescriptionNewRequirementsForUpdatesRequired
} from "../../helpers/functions";
import {
  REGISTER_STEP_FORM_TYPE,
  REGISTRATION_STATUS
} from "../../helpers/smsRegisrtration/constants";
import {IMPLIED_CONSENT_DESCRIBE} from "@/helpers/constants";
import CdModal from "@/components/atomicUIComponents/modal/CdModal.vue";
import CdButton from "@/components/atomicUIComponents/button/CdButton.vue";
import GeneralDetails from "@/components/smsRegistrationComponents/GeneralDetails.vue";

export const EDIT_FORM_VIEW_TYPE = {
  EDIT: 'EDIT',
  READ_ONLY: 'READ_ONLY',
  UPDATES_REQUIRED: 'UPDATES_REQUIRED',
  APPROVED_REGISTRATION_UPDATES_REQUIRED: 'APPROVED_REGISTRATION_UPDATES_REQUIRED',
  APPROVED_OLD_ACCOUNT_NEEDS_UPDATE: 'APPROVED_OLD_ACCOUNT_NEEDS_UPDATE',
}

export default {
  name: "EditRegistrationForm",
  props: {
    viewType: {
      type: String,
    },
  },
  components: {GeneralDetails, CdButton, CdModal, MessageContentType, MessagingDescription, RegisterStepForm},
  mixins: [tenDlcMixin],
  inject: ['openConfirmModal'],
  data() {
    return {
      steps: [{
        key: 1,
        label: 'General details',
      }, {
        key: 2,
        label: 'Messaging Description',
      }, {
        key: 3,
        label: 'Messaging Content',
      }],
      isModalVisible: this.viewType === EDIT_FORM_VIEW_TYPE.UPDATES_REQUIRED,
      currentStep: 1,
      registerInProgress: false,
      isGeneralDetailsValid: false,
      isMessagingDescriptionValid: false,
      isMessageContentValid: false,
      messagingDescriptionData: {
        onlineCheckBox: {
          isCheck: false,
          header: "Online (Site, Mobile app/browser)",
          url: "",
          describe: "",
        },
        verbalCheckBox: {
          isCheck: false,
          header: "Verbal Interaction",
          url: "",
          describe: "",
          verbalEditEnable : false
        },
        paperCheckBox: {
          isCheck: false,
          header: "Paper Form",
          url: "",
          describe: "",
        },
        impliedCheckBox: {
          isCheck: false,
          header: "Implied consent (recipients message us first)",
          url: "",
          describe: IMPLIED_CONSENT_DESCRIBE,
        },
        typicalMessage: "",
        linkToPrivacyPolicy: "",
        linkToTermsAndConditions: "",
      },
      messageContentDetails: {
        campaignSamples: {sample1: "", sample2: ""},
        stopMessage: '',
        helpMessage: '',
        stopMessageEditable: false,
        helpMessageEditable: false,
        supportPhone: "",
        supportEmail: "",
        supportUrl: ""
      },
      registrationDetails: {
        companyName: '',
        ein: '',
        vertical: '',
        contactName: '',
        displayName:'',
        firstName: '',
        lastName: '',
        mobilePhone: '',
        email: '',
        verificationEmail: '',
        street: '',
        city: '',
        state: '',
        postalCode: '',
        country: '',
        website: '',
        e164: '',
        entityType: '',
        stockExchange: '',
        stockSymbol: '',
        volumeType: process.env.VUE_APP_CAMPAIGN_LOW_USE_CASE
      },
    }
  },
  watch: {
    viewType() {
      this.currentStep = 1;
    },
  },
  methods: {
    ...mapActions('smsRegistrations', ['updateQuickFlowCampaign', 'setShownEditView']),
    ...mapActions(["sendAmplitudeEvent"]),
    handleStatusInfoClick(event) {
      if(event.target.dataset.setEditView) {
        this.openConfirmModal({
          header: this.$t('smsRegistrations.statusPage.editRegistrationInfoModalTitle'),
          message: this.$t('smsRegistrations.statusPage.editRegistrationInfoModalText'),
          confirmText: this.$t('smsRegistrations.statusPage.editRegistrationInfoModalConfirmButtonText'),
          connotation: 'alert',
          onConfirm: () => {
            this.setShownEditView(event.target.dataset.setEditView);
          },
        });
      }
    },
    onGeneralDetailsValid(val) {
      this.isGeneralDetailsValid = val
    },
    onMessagingDescriptionValid(val) {
      this.isMessagingDescriptionValid = val
    },
    onMessageContentValid(val) {
      this.isMessageContentValid = val
    },
    closeForm() {
      if (this.shouldConfirmDiscard) {
        this.openConfirmModal({
          header: this.$t('smsRegistrations.statusPage.updatesRequiredRegistrationDiscardChangesModalTitle'),
          message: this.viewType === EDIT_FORM_VIEW_TYPE.EDIT ?
              this.$t('smsRegistrations.statusPage.updatesRequiredRegistrationDiscardChangesModalText.voluntaryEdit') :
              this.$t('smsRegistrations.statusPage.updatesRequiredRegistrationDiscardChangesModalText.actionRequired'),
          confirmText: this.$t('smsRegistrations.statusPage.updatesRequiredRegistrationDiscardChangesModalConfirmButtonText'),
          cancelText: this.$t('smsRegistrations.statusPage.updatesRequiredRegistrationDiscardChangesModalCancelButtonText'),
          connotation: "warning",
          onConfirm: () => {
            this.setShownEditView(false);
          },
        });
      } else {
        this.setShownEditView(false);
      }
    },
    async submitForm() {
      if (this.shouldConfirmSubmit) {
        this.openConfirmModal({
          header: this.$t('smsRegistrations.statusPage.editRegistrationSaveModalTitle'),
          message: this.$t('smsRegistrations.statusPage.editRegistrationSaveModalText'),
          confirmText: this.$t('smsRegistrations.statusPage.editRegistrationSaveModalConfirmButtonText'),
          connotation: 'alert',
          onConfirm: async() => {
            await this.updateCampaign();
          },
        });
      } else {
        await this.updateCampaign();
      }
    },
    async updateCampaign() {
      this.registerInProgress = true;
      const stopMessage = "Reply STOP to opt out";
      this.messageContentDetails.campaignSamples = Object.fromEntries(
          Object.entries(this.messageContentDetails.campaignSamples).map(([key, value]) => [
            key,
            value && value.trim() && !value.trim().endsWith(stopMessage) ? value + " " + stopMessage : value
          ])
      );
      const messagingDescriptionPageFiltered = Object.entries(this.messagingDescriptionData).filter(([, value]) => {
        return typeof value !== 'object' || value.isCheck !== false
      });
      const messagingDescriptionPage = convertMessagingDescriptionArrayToObj(messagingDescriptionPageFiltered);
      // eslint-disable-next-line no-unused-vars
      const {stopMessageEditable, helpMessageEditable, ...messageContentData} = this.messageContentDetails;

      if (this.registrationResponse?.status === REGISTRATION_STATUS.APPROVED_OLD_CAMPAIGN_NEEDS_UPDATE) {
        await this.sendAmplitudeEvent({
          eventName: "Old Campaigns - Done button pressed",
          eventProperties: {
            'Account Number': this.registrationResponse.account_id,
          },
        });
      }
      await this.updateQuickFlowCampaign({
        registrationDetails : this.registrationDetails,
        messagingDescription: messagingDescriptionPage,
        messageContent: messageContentData
      })
      this.registerInProgress = false;
      this.setShownEditView(false);
    }
  },
  computed: {
    ...mapState('smsRegistrations', ['registrationResponse', 'isVoluntaryEditEnabled']),
    ...mapState(['accountDetails']),
    isNextDisabled() {
      if (this.readOnly && this.currentStep < this.steps.length) {
        return false;
      }
      if (this.currentStep === 1) {
        return !this.isGeneralDetailsValid;
      } else if (this.currentStep === 2) {
        return !this.isMessagingDescriptionValid;
      } else  {
        return !this.isMessageContentValid;
      }
    },
    stepFormType() {
      if (this.viewType === EDIT_FORM_VIEW_TYPE.UPDATES_REQUIRED) {
        return REGISTER_STEP_FORM_TYPE.UPDATES_REQUIRED;
      } else {
        return REGISTER_STEP_FORM_TYPE.EDIT_APPROVED_REGISTRATION;
      }
    },
    readOnly() {
      return this.viewType === EDIT_FORM_VIEW_TYPE.READ_ONLY;
    },
    shouldConfirmSubmission() {
      return this.viewType !== EDIT_FORM_VIEW_TYPE.UPDATES_REQUIRED
    },
    isUpdatesRequired() {
      if (!this.registrationResponse.update_required_explanation) {
        return false;
      }

      return [
        EDIT_FORM_VIEW_TYPE.UPDATES_REQUIRED,
        EDIT_FORM_VIEW_TYPE.APPROVED_REGISTRATION_UPDATES_REQUIRED,
        EDIT_FORM_VIEW_TYPE.APPROVED_OLD_ACCOUNT_NEEDS_UPDATE,
      ].includes(this.viewType);
    },
    shouldConfirmDiscard() {
      return [
        EDIT_FORM_VIEW_TYPE.EDIT,
        EDIT_FORM_VIEW_TYPE.APPROVED_REGISTRATION_UPDATES_REQUIRED,
        EDIT_FORM_VIEW_TYPE.APPROVED_OLD_ACCOUNT_NEEDS_UPDATE,
      ].includes(this.viewType);
    },
    shouldConfirmSubmit() {
      return this.viewType !== EDIT_FORM_VIEW_TYPE.UPDATES_REQUIRED;
    },
  },
  beforeMount() {
    if (this.registrationResponse) {
      this.messageContentDetails = convertRegistrationResponseToMessageContentPage(this.registrationResponse)
      const tempMessagingDescriptionData = convertRegistrationResponseToMessagingDescriptionPage(this.registrationResponse)
      this.messagingDescriptionData = handleMessagingDescriptionNewRequirementsForUpdatesRequired(tempMessagingDescriptionData);
      this.registrationDetails.companyName = this.registrationResponse.vonage_api_brand_request.company_name;
      this.registrationDetails.ein = this.registrationResponse.vonage_api_brand_request.ein;
      this.registrationDetails.vertical = this.registrationResponse.vonage_api_brand_request.vertical;
      this.registrationDetails.contactName = this.accountDetails.ContactName;
      this.registrationDetails.email = this.registrationResponse.vonage_api_brand_request.email;
      this.registrationDetails.street = this.registrationResponse.vonage_api_brand_request.street;
      this.registrationDetails.city = this.registrationResponse.vonage_api_brand_request.city;
      this.registrationDetails.state = this.registrationResponse.vonage_api_brand_request.state;
      this.registrationDetails.postalCode = this.registrationResponse.vonage_api_brand_request.postal_code;
      this.registrationDetails.country = this.registrationResponse.vonage_api_brand_request.country;
      this.registrationDetails.website = this.registrationResponse.vonage_api_brand_request.website;
      this.registrationDetails.e164 = '+' + this.registrationResponse.vonage_api_brand_request.phone;
      this.registrationDetails.entityType = this.registrationResponse.vonage_api_brand_request?.entity_type;
      this.registrationDetails.stockExchange = this.registrationResponse.vonage_api_brand_request?.stock_exchange ?? '';
      this.registrationDetails.stockSymbol = this.registrationResponse.vonage_api_brand_request?.stock_symbol ?? '';
      this.registrationDetails.displayName = this.registrationResponse.vonage_api_brand_request?.display_name ?? '';
      this.registrationDetails.verificationEmail = this.registrationResponse.vonage_api_brand_request?.verification_email ?? '';
      this.registrationDetails.hasTaxId = this.registrationResponse.vonage_api_brand_request?.entity_type ?
          this.registrationResponse.vonage_api_brand_request.entity_type !== 'SOLE_PROPRIETOR' : undefined;
      // Sole Proprietor
      this.registrationDetails.firstName = this.registrationResponse.vonage_api_brand_request?.first_name ?? '';
      this.registrationDetails.lastName = this.registrationResponse.vonage_api_brand_request?.last_name ?? '';
      this.registrationDetails.mobilePhone = this.registrationResponse.vonage_api_brand_request?.mobile_phone ?? '';
    }
  }
}
</script>

<style scoped>
.modal-text {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
}
.modal-icon {
  position: absolute;
  top: 26px;
  left: 205px;
}
.footer {
  border-top: none;
  margin: 24px 0 -24px;
  display: flex;
  justify-content: flex-end;
}
.image {
  padding-bottom: 24px;
}
.close-preview-button {
  margin-right: auto;
}

.attention {
  background: #E8F4FB;
  border: 1px solid #0276D5;
}

.info-container {
  box-sizing: border-box;
  border-radius: 6px;
  padding: 20px 16px;
  display: flex;
  width: 100%;
  position: relative;
  flex-direction: row;
  gap: 16px;
  margin-bottom: 16px;
}

</style>
